import { Injectable } from '@angular/core';
import { AuthenticationService } from "../security/AuthenticationService";
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { StorageService, SessionData } from '../security/StorageService';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class IdleService {

    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    TIMEOUT_MINUTES: number = 5;

    constructor(private authenticationService: AuthenticationService, private idle: Idle, private storageService : StorageService) {
        //alert("test")
            let token = this.storageService.getSessionData().token;
            let decoded = jwt_decode(token);
            this.idle.setIdle(this.TIMEOUT_MINUTES * 60);
            this.idle.setTimeout(this.TIMEOUT_MINUTES*60);
            this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

            this.idle.onIdleEnd.subscribe(() => {
                this.idleState = 'No longer idle.';
                console.log(this.idleState)
                });
        
                // the user has timed out (meaning idleDuration + timeout has passed without any activity)
                this.idle.onTimeout.subscribe(() => {
                    this.idleState = 'Timed out!';
                    console.log(this.idleState)
                    this.timedOut = true;
                    this.logout();
                });
        
                this.idle.onIdleStart.subscribe(() => { this.idleState = 'You\'ve gone idle!'; console.log(this.idleState)}); // the user appears to have gone idle
                this.idle.onIdleEnd.subscribe(() => { this.idleState = 'Come back';  console.log(this.idleState)}); // the user has come back
                this.idle.onTimeoutWarning.subscribe((countdown) =>{ this.idleState = 'You will time out in ' + countdown + ' seconds!';  console.log(this.idleState)});
        
                // start watching when the app runs. also starts the Keepalive service by default.
                this.reset(); 
       
        
        
    }

    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }

    logout() {
        this.authenticationService.logout();
        window.location.reload();

    }

}


// WEBPACK FOOTER //
// ./src/app/shared/idle/idle.service.ts